import { Stack, Typography, useTheme } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { makeStyles } from 'tss-react/mui';

interface Props {
  size?: 'small' | 'normal' | 'medium' | 'large';
  inline?: boolean;
  text?: string;
  gap?: number;
  textSize?: number;
}

const PaiDotLoader: React.FC<Props> = ({ size, inline, text, gap, textSize }) => {
  const { classes } = useStyles({ textSize });
  const theme = useTheme();

  const smallHeight = 19.5;
  const normalHeight = 32;
  const mediumHeight = 48;
  const largeHeight = 100;

  const smallRadius = 3;
  const normalRadius = 5;
  const mediumRadius = 8;
  const largeRadius = 10;

  const height = _.isNil(size)
    ? normalHeight
    : size === 'small'
    ? smallHeight
    : size === 'normal'
    ? normalHeight
    : size === 'medium'
    ? mediumHeight
    : size === 'large'
    ? largeHeight
    : normalHeight;

  const radius = _.isNil(size)
    ? normalRadius
    : size === 'small'
    ? smallRadius
    : size === 'normal'
    ? normalRadius
    : size === 'medium'
    ? mediumRadius
    : size === 'large'
    ? largeRadius
    : normalRadius;

  return (
    <div className={!inline ? classes.loader : undefined}>
      <Stack gap={!_.isNil(gap) ? gap : 2} justifyContent={'center'} alignItems={'center'}>
        <ThreeDots color={theme.palette.primary.main} height={height} width={height} radius={radius} />
        {!_.isNil(text) ? <Typography className={classes.loadingText}>{text}</Typography> : null}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles<{ textSize?: number }>()((theme, { textSize }) => ({
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  loadingText: {
    fontSize: theme.typography.pxToRem(textSize || 12),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textAlign: 'center',
  },
}));

export default PaiDotLoader;
